import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        // Vérifier si le consentement a déjà été donné
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            // Délai pour ne pas agresser l'utilisateur immédiatement
            const timer = setTimeout(() => {
                setMounted(true);
                // Petit délai supplémentaire pour l'animation CSS
                requestAnimationFrame(() => setIsVisible(true));
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'true');
        setIsVisible(false);
        setTimeout(() => setMounted(false), 500);
    };

    const handleRefuse = () => {
        // On stocke le refus pour ne pas redemander
        localStorage.setItem('cookie_consent', 'false');
        setIsVisible(false);
        setTimeout(() => setMounted(false), 500);
    };

    if (!mounted) return null;

    return (
        <div className={`cookie-consent-container ${isVisible ? 'visible' : ''}`} role="dialog" aria-modal="false" aria-label="Consentement aux cookies">
            <div className="cookie-content">
                <span className="cookie-icon" role="img" aria-label="Cookie">🍪</span>
                <div className="cookie-text">
                    <p>
                        Nous utilisons des cookies pour améliorer votre expérience utilisateur et réaliser des statistiques de visites.
                        <br />
                        Pour en savoir plus, consultez notre <Link to="/mentions-legales">politique de confidentialité</Link>.
                    </p>
                </div>
            </div>
            <div className="cookie-actions">
                <button className="btn btn-ghost btn-sm" onClick={handleRefuse}>
                    Refuser
                </button>
                <button className="btn btn-primary btn-sm" onClick={handleAccept}>
                    Accepter
                </button>
            </div>
        </div>
    );
}
